// removed by extract-text-webpack-plugin
module.exports = {"select":"xR8i3cyJ5 JmRuDZRyu y4wLu1mD3 vUrsJl1Yt _19QZFK_l1 _1NlI_spEh _1EdaqRqa1 _2OFXNnC9U vUrsJl1Yt _2WNDOuoxI _2G3rNmNVu"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/setupform-form/field/event-type-selector/event-type-selector-category/event-type-selector-category.css
 ** module id = 2158
 ** module chunks = 0
 **/